import { Stack, StackProps, Box, Typography, TypographyProps } from "@mui/material";
import { IRankingData } from "src/components/common/ranking/types";
import { PopoverButtonIconInfo } from "src/components-mui/base/wf-popover/popover-button-icon-info";
import { WfPopover } from "src/components-mui/base/wf-popover/wf-popover";
import { IFractionDigits } from "src/hooks/formatters/number-formatter";
import { ITooltip } from "src/types/common";
import { IRankingValueSize, RankingValue } from "./ranking-value";

export interface IRanking {
    size: IRankingValueSize;
    fractionDigits?: IFractionDigits;
    tooltip?: ITooltip | null;
    data: IRankingData;
    hidePoints?: boolean;
    labelProps?: TypographyProps;
}

export interface IRankingProps extends IRanking, StackProps {}

export const Ranking = ({ data, size, fractionDigits, tooltip, hidePoints, labelProps, ...stackProps }: IRankingProps) => {
    return (
        <Stack component="dl" direction="column" alignItems="center" sx={{ overflow: "hidden", mx: 0.5 }} {...stackProps}>
            <Box component="dt" fontWeight="bold" maxWidth="100%">
                <RankingValue size={size} data={data} fractionDigits={fractionDigits} hidePoints={hidePoints} />
            </Box>
            <Stack component="dd" direction="row" alignItems="center" spacing={0.5} sx={{ maxWidth: "100%" }}>
                <Typography component="span" color="gray.500" fontSize="xs" sx={{ wordBreak: "break-all" }} noWrap {...labelProps}>
                    {data.label}
                </Typography>
                {tooltip && <WfPopover PopoverTrigger={<PopoverButtonIconInfo ariaLabel={data.label} />} {...tooltip}></WfPopover>}
            </Stack>
        </Stack>
    );
};
